import type { LOCATION_SEARCH_TYPE } from '@/types'
import { Heading } from '@pcln/horizon'
import UrgencyMessage from './UrgencyMessage'
import useHotelFormHeadline from './useHotelFormHeadline'

type HotelsSearchFormHeaderProps = {
  location: LOCATION_SEARCH_TYPE | undefined
  subheadline: string
}

export default function HotelsSearchFormHeader({
  location,
  subheadline,
}: Readonly<HotelsSearchFormHeaderProps>) {
  const headline = useHotelFormHeadline(location)

  return (
    <>
      <div className='flex pb-1'>
        <Heading
          as='h1'
          palette='primary'
          shade='12'
          textStyle='heading3'
          className='m-0 text-heading3 lg:text-heading2'
        >
          {headline}
        </Heading>
        <UrgencyMessage location={location} my='auto' ml={3} />
      </div>
      <Heading
        as='h2'
        palette='neutral'
        shade='10'
        textStyle='subheading4'
        className='m-0 pb-3 font-normal max-lg:text-subheading3'
      >
        {subheadline}
      </Heading>
    </>
  )
}
